import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggle } = useTheme();

  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      className={`relative w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200 ${
        theme === 'dark'
          ? 'bg-amber-400/10 text-amber-400 hover:bg-amber-400/20'
          : 'bg-stone-100 text-stone-500 hover:bg-stone-200'
      } ${className}`}
    >
      {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};

export default ThemeToggle;
